import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useGlobalData } from '../../context/globalDataContxt';

import defaultPerson from '../../images/person.jpg';
import './Professionals.scss'

export const Professionals = ({ title, professionals }) => {
  
  const { professionalsAll } = useGlobalData();
  
  const customProfessionalList = professionals.map((item) =>
    professionalsAll.find((prof) => prof.id === item.professional.id)
  )

  return (
    professionals && (
      <div className="container my-5 professionals-section">
        <h2 className="text-uppercase title mb-4">{title}</h2>

        <div className="row justify-content-around">
          {professionals.map((professionals, index) =>
            professionals.visible && (
              <div
                key={`professionalsId-${professionals.id}`}
                className={`col-12 col-sm-6 col-lg-3 mb-4`}
              >
                <div className="professional-card shadow-sm rounded px-4 pt-4 pb-2 h-100 d-flex flex-column align-items-center">
                  <div
                    role="img"
                    alt={professionals.professional?.profilePictureName || ''}
                    className="img-prof mb-3"
                    style={{
                      backgroundImage: `${
                        professionals.professional?.profilePicture
                          ? `url(${professionals.professional.profilePicture.url})`
                          : `url(${defaultPerson})`
                      }`
                    }}
                  ></div>
                  
                  <h6 className="text-center">
                    {professionals.professional.name}
                  </h6>

                  {professionals.rol &&
                    <h6 className="mb-3">
                      <small>{professionals.rol}</small>
                    </h6>
                  }

                  <div className="pt-2 border-top mb-2 flex-grow-1 d-flex flex-column">
                    <div className="pr-1 info-cont position-relative overflow-auto">
                      <p>{professionals.professional.description}</p>
                    </div>
                  </div>

                  {customProfessionalList[index]?.profesionalLinks.length > 0 ? (
                    <div className="social w-100 d-flex justify-content-center pt-2 border-top mb-2">
                      {customProfessionalList[index].profesionalLinks.map((item, index) => {
                        switch (item.type) {
                          case 'facebook':
                            return (
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-facebook"
                                rel="noreferrer"
                                aria-label='facebook link'
                              >
                                {' '}
                                <FontAwesomeIcon
                                  icon={['fab', 'facebook-f']}
                                />
                              </a>
                            )
                          case 'youtube':
                            return (
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-youtube"
                                rel="noreferrer"
                                aria-label='youtube link'
                              >
                                <FontAwesomeIcon icon={['fab', 'youtube']}/>
                              </a>
                            )
                          case 'linkedin':
                            return (
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-linkedin"
                                rel="noreferrer"
                                aria-label='linkedin link'
                              >
                                <FontAwesomeIcon icon={['fab', 'linkedin-in']}/>
                              </a>
                            )
                          case 'twitter':
                            return (
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-twitter"
                                rel="noreferrer"
                                aria-label='twitter-x link'
                              >
                                <FontAwesomeIcon icon={['fab', 'x-twitter']}/>
                              </a>
                            )
                          case 'instagram':
                            return (
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-instagram"
                                rel="noreferrer"
                                aria-label='instagram link'
                              >
                                <FontAwesomeIcon icon={['fab', 'instagram']}/>
                              </a>
                            )
                          case 'curriculum':
                            return (
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-curriculum"
                                rel="noreferrer"
                                aria-label='curriculum link'
                              >
                                <FontAwesomeIcon icon={['fas', 'file']}/>
                              </a>
                            )
                          case 'correo':
                            return (
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-correo"
                                rel="noreferrer"
                                aria-label='correo link'
                              >
                                <FontAwesomeIcon icon={['far', 'envelope']}/>
                              </a>
                            )
                          case 'otro':
                            return (  
                              <a
                                key={`socail-${index}`}
                                href={item?.url}
                                target="_blank"
                                className="btn btn-social m-1 rounded-circle btn-social-icon btn-other"
                                rel="noreferrer"
                                aria-label='another link'
                              >
                                <FontAwesomeIcon icon={['fas', 'link']} />
                              </a>
                            )
                          default:
                            return null
                        }
                      })}
                    </div>
                  ) : null}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    )
  )
}

export default Professionals

Professionals.propTypes = {
  professionals: PropTypes.array.isRequired
}